import React, { memo } from "react";

import Owner from "./owner";

import styles from "../formSections.module.scss";

const Owners = ({
	formName,
	sectionName,
	change,
	fields,
	ownersValidationInfo,
	removeOwner,
	allLoading,
	isTinOptional,
	hiddenFieldsOnMPA,
	isPaperApplication,
	isBadgeShown,
}) => {
	const owners = fields.getAll() || [];
	// eslint-disable-next-line no-unused-vars
	let [firstOwner, ...restOwners] = owners;

	return (
		<>
			<Owner
				{...{
					formName,
					sectionName,
					change,
					owner: "owners[0]",
					index: 0,
					ownersValidationInfo,
					removeOwner,
					allLoading,
					isTinOptional,
					hiddenFieldsOnMPA,
					isPaperApplication,
					isBadgeShown,
				}}
			/>
			{restOwners &&
				restOwners.map((owner, index) => (
					<span key={`${index}owner`}>
						<hr className={styles.divider} />
						<Owner
							{...{
								formName,
								sectionName,
								change,
								owner: `owners[${index + 1}]`,
								index: index + 1,
								ownersValidationInfo,
								removeOwner,
								allLoading,
								isTinOptional,
								hiddenFieldsOnMPA,
								isPaperApplication,
							}}
						/>
					</span>
				))}
		</>
	);
};

export default memo(Owners);
